import type { ExternalPartners } from "@/briefpoint-client";
import type { ClientResponse, ExternalClientResponse } from "@/lib/types";

export interface CombinedClientSearch {
  name: string;
  partner?: ExternalPartners;
  externalId?: string;
  internalId?: string;
}

export const mergeClients = (
  clients?: ClientResponse[],
  externalClients?: ExternalClientResponse[],
) => {
  let mappedClients: CombinedClientSearch[];
  mappedClients =
    clients?.map((c) => ({
      name: c.name ?? "",
      partner: c.integration?.partner,
      externalId: c.integration?.identifier ?? undefined,
      internalId: c.id,
    })) ?? [];

  if (!externalClients?.length) {
    return mappedClients;
  }

  const mappedExternal: CombinedClientSearch[] = externalClients.map((c) => ({
    name: c.name ?? "",
    partner: c.partner,
    // @ts-expect-error: TODO: ExternalClient type definition does not include integration
    externalId: c.integration?.identifier ?? undefined,
    internalId: undefined,
  }));

  for (let i = 0; i < mappedExternal.length; i++) {
    const element = mappedExternal[i];
    const internal = mappedClients.find(
      (x) =>
        x.partner === element.partner && x.externalId === element.externalId,
    );

    if (internal) {
      element.internalId = internal.internalId;
      mappedClients = mappedClients.filter(
        (c) => c.internalId !== internal.internalId,
      );
    }
  }

  return mappedClients.concat(mappedExternal);
};
